import React from 'react';
import clientConfig from '../../../client-config';
import BasePortableText from '@sanity/block-content-to-react';
import serializers from './serializers';
import styled from 'styled-components';

// We need to the first parent of all the blocks to be a flex container.
const PortableTextWrapper = styled.div`
  .block-wrapper {
    display: flex;
    flex-direction: column;
  }
`;

const PortableText = ({ blocks }) => (
  <PortableTextWrapper>
    <BasePortableText
      blocks={blocks}
      serializers={serializers}
      className="block-wrapper"
      {...clientConfig.sanity}
    />
  </PortableTextWrapper>
);

export default PortableText;
